import React from "react";
import BookGrid from "../components/BookGrid/BookGrid";

const Home = () => {
  return (
    <main class="py-12 px-6 2xl:px-6 container">
      <BookGrid />
    </main>
  );
};

export default Home;
